import React, { useState, useEffect } from "react";
import Masters_header from "../Masters_header";
import CommonPagination from "../../../CommonPagination/CommonPagination";
import ConfirmDialog from "../../../ConfirmDialog/ConfirmDialog";
import Vector from "../../../assets/svg/editIcon.svg";
import Delete from "../../../assets/svg/DeleteIcon.svg";
import { ToastContainer, toast } from "react-toastify";
import CommonFooter from "../../../CommonFooter/CommonFooter";
import axiosInstance from "../../../axiosInstance";
import "../../../styles/PlantCode.css";
import PlantCodeCreation from "./PlantCodeCreation";
import { usePermissions } from '../../../hooks/PermissionContext';
import PermissionWrapper from '../../../hooks/PermissionWrapper';

const PlantCodeListing = () => {

    let ModuleId = 30
    const { getModulePermission } = usePermissions();
    const permission = getModulePermission(ModuleId);
    console.log("activeModuleId", ModuleId);
    const [limit, setLimit] = useState(5);
    const [currentPage, setCurrentPage] = useState(0);
    const [skip, setSkip] = useState(0);
    const [total, setTotal] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [searchTerm, setSearchTerm] = useState("");
    const [tableData, setTableData] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [openPlantPopup, setOpenPlantPopup] = useState(false);
    const [editPlantId, setEditPlantId] = useState(null);

    const isAllSelected = selectedRows.length === tableData.length;
    const isAnySelected = selectedRows.length > 0;

    useEffect(() => {
        fetchPlantCodes(searchTerm);
    }, [skip, limit]);

    const fetchPlantCodes = async (term = "") => {
        setIsLoading(true);
        try {
            const response = await axiosInstance.get("/plant_code/list", {
                params: {
                    search: term || undefined,
                    limit,
                    skip,
                },
            });

            if (response.data && Array.isArray(response.data.plant_code)) {
                const plantcodes = response.data.plant_code;
                const totalRec = response.data.totalCount || 0;
                const totalPagesCalc = response.data.totalPages || 0;

                setTableData(plantcodes);
                setTotal(totalRec);
                setTotalPages(Math.ceil(totalRec / limit));
            }
        } catch (error) {
            const backendMessage =
                error?.response?.data?.message || "Failed to fetch Plant Codes";
            toast.error(backendMessage);
            console.error("Error fetching plant codes:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleAddNewCreation = () => {
        setEditPlantId(null);
        setOpenPlantPopup(true);
    };

    const handleEditClick = (plantCodeId) => {
        setEditPlantId(plantCodeId);
        setOpenPlantPopup(true);
    };

    const handleDeleteClick = (id) => {
        setDeleteId(id);
        setConfirmOpen(true);
    };

    const confirmDelete = async () => {
        if (!deleteId) return;

        try {
            await axiosInstance.delete(`/plant_code/delete/${deleteId}`);
            toast.success("Plant Code deleted successfully");
            fetchPlantCodes(searchTerm);
        } catch (error) {
            toast.error("Failed to delete Plant Code");
            console.error("Delete error:", error);
        } finally {
            setConfirmOpen(false);
            setDeleteId(null);
        }
    };

    const cancelDelete = () => {
        setConfirmOpen(false);
        setDeleteId(null);
    };

    const handlePageClick = ({ selected }) => {
        const newSkip = selected * limit;
        setCurrentPage(selected);
        setSkip(newSkip);
        setSelectedRows([]);
    };

    const handleLimitChange = (e) => {
        const newLimit = Number(e.target.value);
        setLimit(newLimit);
        setCurrentPage(0);
        setSkip(0);
    };

    const handleSearch = async (term) => {
        setSearchTerm(term);
        setSkip(0);
        await fetchPlantCodes(term);
    };

    return (
        <>
            <Masters_header onSearch={handleSearch} />
            <div className="container">
                <div className="header d-flex justify-content-between">
                    <h3>PlantCode: {total}</h3>

                    <PermissionWrapper permissionKey="create_permission" moduleId={ModuleId}>
                        {!isAnySelected && (
                            <button id="addNewBtn" onClick={handleAddNewCreation}>
                                Add New
                            </button>
                        )}
                    </PermissionWrapper>
                </div>

                <div className="user-table" style={{ overflowX: "auto", scrollBehavior: "smooth" }}>
                    <table>
                        <thead>
                            <tr>
                                <th style={{ textAlign: 'center' }}>S.No</th>
                                <th>Code</th>
                                <th>Division Type</th>
                                <th>Modified Date</th>
                                <th></th>
                            </tr>
                        </thead>

                        <tbody>
                            {tableData.length > 0 ? (
                                tableData.map((row, index) => (
                                    <tr key={row.id}>
                                        <td style={{ textAlign: 'center' }}>{skip + index + 1}</td>
                                        <td>{row.code}</td>
                                        <td>{row.division_type?.map((d) => d.toUpperCase()).join(", ")}</td>
                                        <td>{row.modifieddate}</td>
                                        <td>
                                            <div className="actions" style={{ gap: "10px" }}>

                                                {/* EDIT */}
                                                <PermissionWrapper permissionKey="edit_permission" moduleId={ModuleId}>
                                                    <span
                                                        className="edit-icon"
                                                        style={{
                                                            cursor: "pointer",
                                                            display: "inline-flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            width: "30px",
                                                            height: "30px",
                                                            borderRadius: "50%",
                                                            backgroundColor: "#fff",
                                                        }}
                                                        onClick={() => handleEditClick(row.id)}
                                                    >
                                                        <img src={Vector} alt="Edit" width="14" height="14" />
                                                    </span>
                                                </PermissionWrapper>

                                                
                                                {/* DELETE */}
                                                <PermissionWrapper permissionKey="delete_permission" moduleId={ModuleId}>
                                                    <span
                                                        className="delete-icon"
                                                        style={{
                                                            cursor: "pointer",
                                                            display: "inline-flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            width: "30px",
                                                            height: "30px",
                                                            borderRadius: "50%",
                                                            backgroundColor: "#fff",
                                                        }}
                                                        onClick={() => handleDeleteClick(row.id)}
                                                    >
                                                        <img
                                                            src={Delete}
                                                            alt="Delete"
                                                            width="27"
                                                            height="27"
                                                        />
                                                    </span>
                                                </PermissionWrapper>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5"
                                        style={{
                                            textAlign: "center",
                                            padding: "20px",
                                            fontSize: "14px",
                                            color: "#666",
                                        }}>
                                        {searchTerm
                                            ? `No Plant Code found matching "${searchTerm}"`
                                            : "No Plant Codes available"}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <CommonPagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    limit={limit}
                    onPageChange={handlePageClick}
                    onLimitChange={handleLimitChange}
                />
            </div>
            <CommonFooter />
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
            <ConfirmDialog
                open={confirmOpen}
                title="Delete Confirmation"
                message="Are you sure you want to delete this Plant Code?"
                confirmText="Delete"
                cancelText="Cancel"
                onConfirm={confirmDelete}
                onCancel={cancelDelete}
            />
            {openPlantPopup && (
                <PlantCodeCreation
                    plantCodeId={editPlantId}
                    onClose={() => {
                        setOpenPlantPopup(false);
                        fetchPlantCodes(searchTerm);
                    }}
                />
            )}
        </>
    );
};

export default PlantCodeListing;